import React from "react";
import styles from "./_css/spinnerAlt.module.css";

export function SpinnerAlt() {
    return (
        <div className={styles.container}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}
